// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wa_a bhe_b","TwoDimsListFeature__item":"wa_b bhe_wb","TwoDimsListFeature__item__text":"wa_c bhe_vr"};